import React, { useRef, useState } from "react";
import { Card } from "reactstrap";
import AButton from "../../../../common/form-fields-mui/AButton";
import { useGetCollectPaymentContext } from "../../context";
import {
  epmrDetails,
  formattedPrice,
  // reviewReceipt,
  // validateSequencing,
  shouldShowUploadChequePopup,
} from "../../utils";
import { ReactComponent as EditIcon } from "../../../../../../../assets/img/svg/Edit4.svg";
import { ReactComponent as DeleteIcon } from "../../../../../../../assets/img/svg/DeleteRedOutlined.svg";
import EpmrPaymentDetails from "../epmrValidation";
import EditPaymentDetailsDialog from "./EditPaymentDetailsDialog";
import {
  findPaymentModeKey,
  getPaymentModeDispValue,
  getSwapLabelValue,
  insertElementAtIndex,
} from "../components/constant";
import UploadChequeEpmr from "../components/UploadCheque";
import { getPaymentReferenceNo, isVoucher } from "./utils";

const CollectedPayments = ({ 
  contextValue,
  module,
  title="Payments Collected",
  showNextButton = true
   }) => {
  const {
    collectPayment,
    collectVoucherList,
    setCurrentPageState,
    setCurrentStep,
    studentBasicDetails,
    selectedCharges,
    setBalanceAmount,
    setPaymentModeForm,
    bankDropdown,
    paymentModeForm,
    currentPaymentMode,
    setCurrentPaymentMode,
    setCollectPayment,
    amountToBePaid,
    totalCollectedAmount,
    loader,
    setVouchersDialogOpen,
    validateSequencing,
    reviewReceipt,
    partialAddAmount
  } = useGetCollectPaymentContext(module);

  const [editPaymentDetailsDialogOpen, setEditPaymentDetailsDialogOpen] =
    useState(false);
  const paymentModeList = [...collectPayment, ...collectVoucherList];
  const epmrReceiptDetails = epmrDetails(studentBasicDetails);
  const [uploadChequePopup, setUploadChequePopup] = useState(false);
  const editRestoreData = useRef();

  const editPaymentModeHandler = (form, index) => {
    setCurrentPaymentMode(findPaymentModeKey(form?.paymentMode));
    setPaymentModeForm({
      ...form,
      bank:
        form?.paymentMode === "EFT"
          ? getSwapLabelValue(bankDropdown)?.find(
              (bank) => bank?.label === form?.bankName
            )
          : bankDropdown?.find((bank) => bank?.value === form?.bankName),
      onlineSale: { label: form?.onlineSale, value: form?.onlineSale },
      indexToEdit: index,
    });
    setEditPaymentDetailsDialogOpen(true);
    deletePaymentModeHandler(form, index);
    //storing important info required at the time of edit cancellation
    editRestoreData.current = {
      lastAddedPaymentMode: currentPaymentMode,
      paymentToBeEdited: form,
      indexToEdit: index,
    };
  };

  const dialogCrossClickHandler = () => {
    const { lastAddedPaymentMode, paymentToBeEdited, indexToEdit } =
      editRestoreData?.current;
    setPaymentModeForm({});
    setBalanceAmount((currAmt) => currAmt - +paymentToBeEdited?.paidAmount);
    setCollectPayment((prev) =>
      insertElementAtIndex(prev, paymentToBeEdited, indexToEdit)
    );
    setCurrentPaymentMode(lastAddedPaymentMode);
    setEditPaymentDetailsDialogOpen(false);
  };

  const deletePaymentModeHandler = (form, index) => {
    setBalanceAmount(amountToBePaid - totalCollectedAmount + +form?.paidAmount);
    setCollectPayment((prev) => {
      const tempCollectPayment = [...prev];
      tempCollectPayment.splice(index, 1);
      return tempCollectPayment;
    });
  };

  const checkReview = async () => {
    const isReview = await reviewReceipt(
      {...studentBasicDetails,partialAddAmount},
      amountToBePaid,
      selectedCharges,
      collectPayment,
      collectVoucherList
    );
    if (isReview) {
      setCurrentPageState("REVIEW");
      setCurrentStep((prev) => prev + 1);
    } else return;
  };

 

  const getPaymentDescription = (payment, epmrReceiptDetails) => {

    const paymentName = getPaymentModeDispValue(payment);
    const referenceNo = getPaymentReferenceNo(payment, epmrReceiptDetails)

    return referenceNo ? `${paymentName} - ${referenceNo}` : paymentName;
  };

  const disableReviewAndReceiptBtn = () => {
    if (epmrReceiptDetails) return false;
    if (paymentModeList.length === 0) return true;
    return totalCollectedAmount < amountToBePaid;
  };

  const reviewReceiptHandler = () => {
    if (shouldShowUploadChequePopup(epmrReceiptDetails, collectPayment)) {
      setUploadChequePopup(true);
      return;
    }
    validateSequencing({...studentBasicDetails, partialAddAmount}, selectedCharges, amountToBePaid);
    checkReview();
  };

  return (
    <Card className="p-3">
      <div className="collection-details-card-header mb-3">
        {title}
      </div>
      {collectPayment?.length || collectVoucherList?.length ? (
        <>
          <div className="collection-details-table-header mb-1">
            <span>MODE</span>
            <span className="float-right">AMOUNT</span>
          </div>
          <hr />
          <div style={{ overflow: "scroll", maxHeight: "150px" }}>
            {paymentModeList?.map((payment, index) => (
              <div className="d-flex justify-content-between collected-payment-table-row my-2">
                <span className="collection-details-table-header description-cell d-flex">
                  {getPaymentDescription(payment, epmrReceiptDetails)}
                  <EpmrPaymentDetails epmrReceiptDetails={epmrReceiptDetails} />
                </span>

                <div className="action-cell">
                  {!(
                    ["CC", "DB", "MPOS"]?.includes(payment?.paymentMode) ||
                    epmrReceiptDetails?.epmrNumber ||
                    payment?.isAutoCash ||
                    payment?.isLink
                  ) && (
                    <>
                      {!isVoucher(payment) && (
                        <EditIcon
                          className="cursor"
                          onClick={() => editPaymentModeHandler(payment, index)}
                        />
                      )}

                      <DeleteIcon
                        className="cursor ml-3"
                        onClick={
                          isVoucher(payment)
                            ? () => setVouchersDialogOpen(true)
                            : () => deletePaymentModeHandler(payment, index)
                        }
                      />
                    </>
                  )}
                </div>

                <span className="collection-details-amount-cell">
                  {formattedPrice(payment?.paidAmount)}
                </span>
              </div>
            ))}
          </div>
          <hr />
          <div className="my-2 collection-details-table-header">
            <span>Total amount</span>
            <span className="float-right">
              {formattedPrice(totalCollectedAmount)}
            </span>
          </div>
        </>
      ) : (
        <div className="empty-collected-payments-placeholder">
          Collected payments will be shown here
        </div>
      )}

      {
        showNextButton &&
        <AButton
          variant="primary_filled"
          className="no-ml-btn mt-2"
          disabled={disableReviewAndReceiptBtn()}
          onClick={reviewReceiptHandler}
        >
          Review and receipt
        </AButton>
      }

      <EditPaymentDetailsDialog
        open={editPaymentDetailsDialogOpen}
        setOpen={setEditPaymentDetailsDialogOpen}
        crossClickHandler={dialogCrossClickHandler}
        contextValue={contextValue}
        paymentModeName={getPaymentModeDispValue(paymentModeForm)}
        currentPaymentMode={currentPaymentMode}
        loader={loader}
      />
      <UploadChequeEpmr
        paymentMode={collectPayment[0]?.paymentMode}
        setCollectPayment={setCollectPayment}
        closePopup={setUploadChequePopup}
        openUploadChequePopUp={uploadChequePopup}
        bankDropdown = {bankDropdown}
        collectPayment = {collectPayment}
      />
    </Card>
  );
};

export default CollectedPayments;
